const PropertiesConstant = {
  SIDEBAR_SIZE: 64,
  TOPBAR_SIZE: 64,
  ROWS_PER_PAGE_POSSIBILITIES: [25, 50, 100, 200],
};

export default PropertiesConstant;
